import { CHANNEL_RIGHT_NAME, RIGHTS } from './catalog';
import { RightLevel, RightsMap, rightLevel, weakestLevel } from './levels';

export type CampaignChannel = keyof typeof CHANNEL_RIGHT_NAME;

// Tuile du canal dans « Nouvelle opération » (BeOne : apps/planning/modules/selectChannel/templates/_channel.php) :
// active si le canal ET sa création valent '0', grisée si l'un vaut '1', masquée sinon
export const channelCreationLevel = (level: (key: string) => RightLevel, channel: CampaignChannel): RightLevel => {
  const name = CHANNEL_RIGHT_NAME[channel];
  return weakestLevel(level(`da.${name}`), level(`${RIGHTS.planning.createOperation}.${name}`));
};

// Enseignes où le devis est masqué par défaut (BeOne : planning/modules/validation/config/parameters.yml)
const QUOTATION_HIDDEN_WORKSPACES = ['uhps', 'foirfouille'];

// Devis de la commande : affiché si l'enseigne le montre par défaut ou si da.quotation vaut '0' (même règle que l'API)
export const canSeeQuotation = (rights: RightsMap, workspace: string | undefined): boolean =>
  !QUOTATION_HIDDEN_WORKSPACES.includes((workspace ?? '').toLowerCase()) || rightLevel(rights, RIGHTS.quotation) === 'full';
